"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutocompleteInputOption = void 0;

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _themeGet = require("@styled-system/theme-get");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Clickable = require("../Clickable");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AutocompleteInputOption = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
      selected = _ref.selected,
      rest = _objectWithoutProperties(_ref, ["children", "selected"]);

  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _ref$current$scrollIn, _ref$current;

    if (!ref.current || !selected) return; // @ts-ignore

    if (typeof ref.current.scrollIntoViewIfNeeded === "function") {
      // @ts-ignore
      ref.current.scrollIntoViewIfNeeded();
      return;
    }

    (_ref$current$scrollIn = (_ref$current = ref.current).scrollIntoView) === null || _ref$current$scrollIn === void 0 ? void 0 : _ref$current$scrollIn.call(_ref$current);
  }, [selected]);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: (0, _composeReactRefs.default)(ref, forwardedRef),
    bg: "white100"
  }, rest), children);
});
exports.AutocompleteInputOption = AutocompleteInputOption;
AutocompleteInputOption.displayName = "AutocompleteInputOption";
var Container = (0, _styledComponents.default)(_Clickable.Clickable).withConfig({
  displayName: "AutocompleteInputOption__Container",
  componentId: "fz5j3u-0"
})(["display:block;width:100%;&:focus,&:active{outline:0;background-color:", ";}"], (0, _themeGet.themeGet)("colors.black5"));
//# sourceMappingURL=AutocompleteInputOption.js.map